import React from "react"

import { ManagerFilter } from "./ManagerFilter"

import type { CompanyListFilter } from "@/graphql/codegen/graphql"
import { useManagers } from "@/hooks/api/useManagers"

interface ManagersFilterProps {
  onFilterChange: (name: keyof CompanyListFilter, value: any) => void
}

// Filters companies by any of their managers: the account managers and the product managers.
export const ManagersFilter = React.memo<ManagersFilterProps>(({ onFilterChange }) => {
  const { visibleManagers, fetching } = useManagers()

  return (
    <ManagerFilter title='Managers' managers={visibleManagers} fetching={fetching} onFilterChange={onFilterChange} />
  )
})

ManagersFilter.displayName = "ManagersFilter"
